import { Dispatch } from 'react';
import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { StylesConfig } from 'react-select/dist/declarations/src/styles';
import { Option } from 'react-google-places-autocomplete/build/types';
import { GroupBase } from 'react-select/dist/declarations/src/types';
import { SelectedAddress } from '../../App';

function AddressSearch({ setValue }: { setValue: Dispatch<SelectedAddress| null> }) {

    const noOptionsMessage = () => { return "Address not found" }

    const customStyles : StylesConfig<Option, false, GroupBase<Option>> = {
        control: (styles, state) => ({
            ...styles,
            borderRadius: "0.5rem",
            fontSize: "24px",
            borderColor: state.isFocused ? 'rgb(8 145 178)' : 'rgb(75 85 99)',
        }),
        indicatorSeparator: () => ( { display: 'none' } ),
        dropdownIndicator: () => ( { display: 'none' } ),
    }

    const handleSearchResultSelect = (result: any) => {

        if (!result?.value?.place_id) {
            return;
        }

        geocodeByPlaceId(result.value.place_id)
            .then(results => {

                if (!results || results.length === 0) {
                    return;
                }

                let first = results[0];

                setValue({
                    label: result.label,
                    lat: first.geometry.location.lat(),
                    lng:  first.geometry.location.lng(),
                });

            });
    };


    const countries = process.env.REACT_APP_ADDRESS_SEARCH_COUNTRIES?.split(" ") || ["EE"]

    return (
        <div className="search">
            <GooglePlacesAutocomplete
                apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                minLengthAutocomplete={3}
                selectProps={{
                    onChange: handleSearchResultSelect,
                    openMenuOnClick: false,
                    isClearable: true,
                    placeholder: 'Search address ...',
                    classNamePrefix: 'search',
                    noOptionsMessage: noOptionsMessage,
                    styles: customStyles
                }}
                autocompletionRequest={{
                    componentRestrictions: {
                        country: countries,
                    },
                }}
            />
        </div>
    );
}

export default AddressSearch;
